module.exports = __webpack_public_path__ + "img/podium_3024.da78a80d.jpg";